import React from 'react';
import { Mail, Bot } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  const navLinks = [
    { label: t.nav.home, href: '#hero' },
    { label: t.nav.discover, href: '#entdecken' },
    { label: t.nav.features, href: '#funktionen' },
    { label: t.nav.advantages, href: '#vorteile' },
    { label: t.nav.faq, href: '#faq' },
  ];

  return (
    <footer className="bg-[#05060a] border-t border-border-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-primary to-violet flex items-center justify-center">
                <Bot className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold font-heading">
                Sidekick<span className="text-primary-light"> Download</span>
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-4 max-w-md">{t.footer.blurb}</p>
            <p className="text-slate-500 text-xs leading-relaxed max-w-lg">{t.footer.legalShort}</p>
          </div>

          <div>
            <h4 className="text-xs font-bold text-white uppercase tracking-[0.2em] mb-5">{t.footer.navTitle}</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-slate-400 hover:text-primary-light transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold text-white uppercase tracking-[0.2em] mb-5">{t.footer.contactTitle}</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:support@sidekickdownload.com"
                  className="flex items-center gap-2 text-slate-400 hover:text-primary-light transition-colors text-sm"
                >
                  <Mail className="w-4 h-4 shrink-0" />
                  support@sidekickdownload.com
                </a>
              </li>
            </ul>

            <div className="mt-6">
              <a
                href="/s"
                className="inline-flex items-center bg-gradient-to-r from-primary to-violet text-white px-5 py-2.5 rounded-lg font-bold text-sm transition-all shadow-glow"
              >
                {t.footer.cta}
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-border-dark pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-xs text-center md:text-left">
            © {new Date().getFullYear()} {t.footer.copyright}
          </p>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
            <a href="/agb.html" className="text-slate-500 hover:text-accent transition-colors text-xs">
              {t.footer.agb}
            </a>
            <a href="/datenschutz.html" className="text-slate-500 hover:text-accent transition-colors text-xs">
              {t.footer.privacy}
            </a>
            <a href="/hilfe.html" className="text-slate-500 hover:text-accent transition-colors text-xs">
              {t.footer.help}
            </a>
            <a href="/impressum.html" className="text-slate-500 hover:text-accent transition-colors text-xs">
              {t.footer.imprint}
            </a>
            <a href="/widerruf.html" className="text-slate-500 hover:text-accent transition-colors text-xs">
              {t.footer.widerruf}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
